import React from 'react'

type Props = {}

const Login = (props: Props) => {
    return (
        <>
            
        </>
    )
}

export default Login